import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import moment from 'moment-timezone';
import { setTimeout } from "timers";
import * as FileSaver from 'file-saver';


class OtherCoverageDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            otherCoverage: props.location.state.otherCoverage,
            hpIdentity: props.location.state.hpIdentity,
            swhp: props.location.state.swhp
        };
        this.getFormattedDate = this.getFormattedDate.bind(this);
        this.goToUpdateOtherCoveragePage = this.goToUpdateOtherCoveragePage.bind(this);
        this.goToOtherCoveragePage = this.goToOtherCoveragePage.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.OtherCoverage.ComponentDidMount", new Date(), Tools.getURLPath());
        this.componentDidUpdate(this.props);
    }

    componentDidUpdate(prevProps) {
    }

    getFormattedDate(effDateString) {
        if (effDateString) {
            var effDate = new Date(effDateString);
            return (effDate.getMonth() + 1) + '/' + effDate.getDate() + '/' + effDate.getFullYear();
        }
        return "";
    }

    goToUpdateOtherCoveragePage() {
        this.props.history.push('/updateOtherCoverage', { otherCoverage: this.state.otherCoverage });
    }

    goToOtherCoveragePage() {
        this.props.history.push('/otherCoverage');
    }

    getAddressString(address) {
        var addressString = ""

        if (address) {
            var address1 = address.addressLine1 == null ? "" : address.addressLine1;
            var address2 = address.addressLine2 == null ? "" : " " + address.addressLine2;
            var address3 = address.addressLine3 == null ? "" : " " + address.addressLine3;
            addressString = address1 + address2 + address3 + ", " + address.city + ", " + address.state + " " + address.zipCode;
        }

        return addressString;
    }

    render() {
        return (
            <div className="container-fluid body-content hp">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="coverage-details-wrapper">
                            <div className="coverage-details-container">
                                <div className="row">
                                    <span className="link-text cursor-pointer" onClick={() => this.goToOtherCoveragePage()}>{'< Back'}</span>
                                </div>
                                <div className="hp-title">Other Coverage Details</div>
                                <div className="row other-coverage-policy-holder coverage-details-group">
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-6 bold-text coverage-details-header">
                                                <span>POLICYHOLDER</span>
                                            </div>
                                            <div className={`col-6 edit-coverage-link bold-text ${this.props.swhp ? "hidden" : ""}`} onClick={() => this.goToUpdateOtherCoveragePage()}>EDIT COVERAGE</div>
                                        </div>
                                        <hr></hr>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="row">
                                            <span className="col-6 bold-text">Name</span>
                                            <span className="col-6 coverage-details-data">{this.state.otherCoverage.subscriberName ? this.state.otherCoverage.subscriberName : "N/A"}</span>
                                        </div>
                                        <hr className="hide-mobile"></hr>
                                        <div className="row">
                                            <span className="col-6 bold-text">Date of Birth</span>
                                            <span className="col-6 coverage-details-data">{this.state.otherCoverage.subscriberBirthDate ? this.getFormattedDate(this.state.otherCoverage.subscriberBirthDate) : "N/A"}</span>
                                        </div>
                                        <hr className="show-mobile"></hr>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="row">
                                            <span className="col-6 bold-text">Gender</span>
                                            <span className="col-6 coverage-details-data">{this.state.otherCoverage.subscriberGenderCode ? this.state.otherCoverage.subscriberGenderCode : "N/A"}</span>
                                        </div>
                                        <hr className="hide-mobile"></hr>
                                        <div className="row">
                                            <span className="col-6 bold-text">Relation to Subscriber</span>
                                            <span className="col-6 coverage-details-data">{this.state.otherCoverage.relationToSubscriber ? this.state.otherCoverage.relationToSubscriber : "N/A"}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row other-coverage-insurance-company coverage-details-group">
                                    <div className="col-12 bold-text coverage-details-header">
                                        <span>INSURANCE COMPANY</span>
                                        <hr></hr>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="row">
                                            <span className="col-6 bold-text">Company Name</span>
                                            <span className="col-6 coverage-details-data">{this.state.otherCoverage.companyName ? this.state.otherCoverage.companyName : "N/A"}</span>
                                        </div>
                                        <hr className="hide-mobile"></hr>
                                        <div className="row">
                                            <span className="col-6 bold-text">Address</span>
                                            <span className="col-6 coverage-details-data">{this.state.otherCoverage.companyAddress ? this.getAddressString(this.state.otherCoverage.companyAddress) : "N/A"}</span>
                                        </div>
                                        <hr className="show-mobile"></hr>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="row">
                                            <span className="col-6 bold-text">Phone Number</span>
                                            <span className="col-6 coverage-details-data">{this.state.otherCoverage.companyAddress ? this.state.otherCoverage.companyAddress.telephones[0] ? this.state.otherCoverage.companyAddress.telephones[0].number : "N/A" : "N/A"}</span>
                                        </div>
                                        <hr className="hide-mobile"></hr>
                                    </div>
                                </div>
                                <div className="row other-coverage-policy-details coverage-details-group">
                                    <div className="col-12 bold-text coverage-details-header">
                                        <span>POLICY DETAILS</span>
                                        <hr></hr>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="row">
                                            <span className="col-6 bold-text">Plan Name</span>
                                            <span className="col-6 coverage-details-data">{this.state.otherCoverage.benefitPlanName ? this.state.otherCoverage.benefitPlanName : "N/A"}</span>
                                        </div>
                                        <hr className="hide-mobile"></hr>
                                        <div className="row">
                                            <span className="col-6 bold-text">Coverage Type</span>
                                            <span className="col-6 coverage-details-data">{this.state.otherCoverage.coverageType ? this.state.otherCoverage.coverageType : "N/A"}</span>
                                        </div>
                                        <hr className="hide-mobile"></hr>
                                        <div className="row">
                                            <span className="col-6 bold-text">Alternate Policy Number</span>
                                            <span className="col-6 coverage-details-data">{this.state.otherCoverage.alternatePolicyNumber ? this.state.otherCoverage.alternatePolicyNumber : "N/A"}</span>
                                        </div>
                                        <hr className="hide-mobile"></hr>
                                        <div className="row">
                                            <span className="col-6 bold-text">Effective Date</span>
                                            <span className="col-6 coverage-details-data">{this.state.otherCoverage.startDate ? this.getFormattedDate(this.state.otherCoverage.startDate) : "N/A"}</span>
                                        </div>
                                        <hr className="show-mobile"></hr>
                                    </div>
                                    <hr></hr>
                                    <div className="col-12 col-sm-6">
                                        <div className="row">
                                            <span className="col-6 bold-text">Policy Type</span>
                                            <span className="col-6 coverage-details-data">{this.state.otherCoverage.policyType ? this.state.otherCoverage.policyType : "N/A"}</span>
                                        </div>
                                        <hr className={`hide-mobile ${this.state.otherCoverage.policyType == "Non-Medicare" ? "hidden" : ""}`}></hr>
                                        <div className={`row ${this.state.otherCoverage.policyType == "Non-Medicare" ? "hidden" : ""}`}>
                                            <span className="col-6 bold-text">MBI</span>
                                            <span className="col-6 coverage-details-data">{this.state.otherCoverage.mbi ? this.state.otherCoverage.mbi : "N/A"}</span>
                                        </div>
                                        <hr className="hide-mobile"></hr>
                                        <div className="row">
                                            <span className="col-6 bold-text">Group Number</span>
                                            <span className="col-6 coverage-details-data">{this.state.otherCoverage.groupNumber ? this.state.otherCoverage.groupNumber : "N/A"}</span>
                                        </div>
                                        <hr className="hide-mobile"></hr>
                                        <div className="row">
                                            <span className="col-6 bold-text">Priority</span>
                                            <span className="col-6 coverage-details-data">{this.state.otherCoverage.priority ? this.state.otherCoverage.priority : "N/A"}</span>
                                        </div>
                                        <hr className="hide-mobile"></hr>
                                        <div className="row">
                                            <div className="col-6">
                                                <input type="checkbox" className="coverage-details-checkbox" value={`${this.state.otherCoverage.isCourtOrdered ? "checked" : ""}`} disabled={true} />
                                                <span className="bold-text">Court Ordered Coverage</span>
                                            </div>
                                            <div className="col-6">
                                                <input type="checkbox" className="coverage-details-checkbox" value={`${this.state.otherCoverage.isRetiree ? "checked" : ""}`} disabled={true} />
                                                <span className="bold-text">Retiree Policy</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        swhp: state.domain.hi,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OtherCoverageDetails));
